import type { FilesFileElasticSchemaWithId } from '@iconik-io/iconik-api/src/services/files';

import type { VariantType } from './variants';

export type FileStatus = NonNullable<FilesFileElasticSchemaWithId['status']>;

export const filesStatus: FileStatus[] = [
  'ARCHIVED',
  'AWAITED',
  'CLOSED',
  'DELETED',
  'FAILED',
  'GROWING',
  'MISSING',
  'OPEN',
  'REDISCOVERED',
];

const fileStatusSet: ReadonlySet<string> = new Set(filesStatus);

export const isFileStatus = (value: string): value is FileStatus =>
  fileStatusSet.has(value);

export const filesStatusOptions: {
  value: string;
  label: string;
  style: VariantType;
}[] = [
  { value: 'ARCHIVED', label: 'Archived', style: 'warning' },
  { value: 'AWAITED', label: 'Awaited', style: 'danger' },
  { value: 'CLOSED', label: 'Closed', style: 'success' },
  { value: 'DELETED', label: 'Deleted', style: 'danger' },
  { value: 'FAILED', label: 'Failed', style: 'danger' },
  { value: 'GROWING', label: 'Growing', style: 'danger' },
  { value: 'MISSING', label: 'Missing', style: 'danger' },
  { value: 'OPEN', label: 'Open', style: 'danger' },
  { value: 'REDISCOVERED', label: 'Rediscovered', style: 'warning' },
];

export const formatNames = {
  ORIGINAL: 'ORIGINAL',
  SUBTITLES: 'SUBTITLES',
  WILDMOKA: 'WILDMOKA',
};

export const dropFrameFPS = new Set(['29.97', '59.94']);

export const COMMON_VIDEO_EXTENSION = new Set([
  'mp4',
  'm4p',
  'm4v',
  'asf',
  'viv',
  'amv',
  'rmvb',
  'rm',
  'yuv',
  'avi',
  'mts',
  'm2ts',
  'avchd',
  'mng',
  'gifv',
  'drc',
  '264',
  'h264',
  'mov',
  'qt',
  'mkv',
  'wmv',
  'webm',
  'mpg',
  'mpe',
  'mpv',
  'mpeg',
  'm2v',
  'mp2',
  'ogg',
  'ogv',
  'vob',
  'flv',
  'f4v',
  'f4p',
  'f4a',
  'f4b',
  'nsv',
  'roq',
  '3g2',
  '3gp',
  'svi',
  'swf',
  'r3d',
  'mxf',
]);

export const COMMON_AUDIO_EXTENSION = new Set([
  '3gp',
  'aa',
  'aac',
  'aax',
  'act',
  'aiff',
  'alac',
  'amr',
  'ape',
  'au',
  'awb',
  'dss',
  'dvf',
  'flac',
  'gms',
  'iklax',
  'ivs',
  'm4a',
  'm4b',
  'm4p',
  'mmf',
  'mp3',
  'mpc',
  'msv',
  'nmf',
  'oga',
  'mogg',
  'opus',
  'ra',
  'rm',
  'rf64',
  'sln',
  'tta',
  'voc',
  'wma',
  'wav',
  'acc',
]);

export const COMMON_IMAGE_EXTENSION = new Set([
  'jpeg',
  'jpg',
  'jfif',
  'jp2',
  'jpx',
  'exif',
  'tiff',
  'gif',
  'bmp',
  'png',
  'webp',
  'hdr',
  'heif',
  'ico',
  'psd',
  'svg',
  'ai',
  'eps',
  'raw',
  'cr2',
  'nef',
  'orf',
  'sr2',
  'xcf',
  'cdr',
]);
